/**Enum che rappresenta la tipologia di ricerca lemma, parola, etc */
export enum formType {
    lemma = 'lemma',
    keyWord = 'keyword'
}

/**Enum che rappresenta le possibili estensioni della ricerca (iponimi, iperonimi, etc) */
export enum extensionType {
    empty = '',
    hyponym = 'hyponym',
    synonym = 'synonym',
    hyperonym = 'hypernym'
}